import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { useTaktId, createStormTaktId, styleMixinFocusOutline } from '@amzn/storm-ui';
import { N as NumericLabel } from './Label/NumericLabel-C43p7PpZ.js';
import { l as labelContainerBorderRadius } from './Label/LabelContainer-B-AAu4SJ.js';

const OptionInput = /*#__PURE__*/styled.input.attrs({
  type: 'radio'
}).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1q0o5m-0"
})(["appearance:none;border:none;margin:0;padding:0;display:inline;outline:0;position:absolute;"]);
const StyledLabel = /*#__PURE__*/styled.label.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1q0o5m-1"
})(["padding-left:0;padding-bottom:0;padding-right:0;padding-top:0;flex-grow:1;", " :focus-within{outline:none;", "}"], labelContainerBorderRadius, styleMixinFocusOutline);
const handleKeyDown = event => {
  const {
    key
  } = event;
  if (key === 'Enter') {
    event.preventDefault();
  }
};
function NumericOptionWrapper({
  id,
  name,
  label,
  value,
  checked,
  onChange,
  disabled,
  className,
  children,
  taktId,
  taktValue
}) {
  const handleChange = React__default.useCallback(event => {
    if (!disabled) {
      onChange(event);
    }
  }, [onChange, disabled]);
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId(`option-${value}`)
  });
  return /*#__PURE__*/React__default.createElement(StyledLabel, _extends({
    htmlFor: id,
    className: className
  }, getDataTaktAttributes({
    taktValue
  })), /*#__PURE__*/React__default.createElement(OptionInput, {
    id: id,
    checked: checked,
    "aria-checked": checked,
    "aria-label": label,
    disabled: disabled,
    "aria-disabled": disabled,
    name: name,
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown
  }), children({
    checked,
    disabled,
    label,
    value
  }));
}
function NumericOption(optionProps) {
  return /*#__PURE__*/React__default.createElement(NumericOptionWrapper, optionProps, props => /*#__PURE__*/React__default.createElement(NumericLabel, props));
}

export { NumericOptionWrapper as N, NumericOption as a };
//# sourceMappingURL=NumericOption-BEP7gL-p.js.map
